export function wrapIframe(html) {
  if (!html || typeof html !== 'string') return '';

  // Ubah YouTube URL jadi iframe
  return html.replace(
    /(https?:\/\/(?:www\.)?(?:youtube\.com\/watch\?v=|youtu\.be\/)([\w-]+))/g,
    (_, __, videoId) => {
      return `
        <div class="aspect-video w-full my-6 rounded-xl overflow-hidden">
          <iframe
            src="https://www.youtube.com/embed/${videoId}"
            class="w-full h-full"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
      `;
    }
  );
}
